// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "babel-polyfill"
import Vue from 'vue'
import App from './App'
import VueMatomo from 'vue-matomo'
import router from './router'
import store from './store/index'
import VueWechatTitle from 'vue-wechat-title'
import { Pagination, Input, Dropdown,  DropdownMenu, DropdownItem, Carousel, CarouselItem, Message, Button } from 'element-ui'
//import { relative } from "path";
import { cyLoginUrl, mcyApi } from './config/env'
import Interval from './utils/Interval.js'
//解决跨域问题
import VueResource from 'vue-resource'
//图片懒加载
import VueLazyload from 'vue-lazyload'
Vue.use(VueResource)
Vue.use(Interval)
Vue.use(VueWechatTitle)
Vue.use(Pagination)
Vue.use(Input)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Button)
Vue.use(VueLazyload, {
  preLoad: 1.3, //proportion of pre-loading height
  //error: '/static/images/error.png',//src of the image upon load fail
  // loading: '/static/images/loading.gif', //src of the image while loading
  attempt: 1 //attempts count

})
Vue.use(VueMatomo, {
  // Configure your Matomo server and site by providing:
  host: 'https://matomo.dd-img.com/',
  siteId: 2,
})
window._paq.push(['trackPageView']); // To track a page view
Vue.component(Message.name, Message)
Vue.config.productionTip = false
Vue.prototype.$message = Message;
// 自定义指令实现back-top;
// Vue.directive('scroll-show',{
//   inserted(el, binding){
//     let scope = binding.arg || '200';
//     window.addEventListener('scroll', function(e){
//       if (this.scrollY > Number(scope)) {
//         binding.value.value = true;
//       } else {
//         binding.value.value = false;
//       }
//     })
//   }
// })
// Vue.directive('back-top',{
//   inserted(el, binding){
//     let e = binding.arg || 'click';
//     el.addEventListener(e, function(){
//       let scrollToptimer = setInterval(function(){
//         let top = document.documentElement.scrollTop + document.body.scrollTop;
//         let speed = top/4;
//         top -= speed;
//         document.documentElement.scrollTop = document.body.scrollTop = top;
//         if (top == 0) {
//           clearInterval(scrollToptimer);
//         }
//       }, 30)
//     })
//   }
// })
router.beforeEach((to, from, next) => {
  //详情页 如果是手机端打开要跳转到移动端
  let name = to.name;
  var ismobile = /Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent);
  if (ismobile) {
    if (name == 'index') {
      window.location.href =  mcyApi;
      return;
    } else if (name == 'newsFlash'){
      window.location.href =  mcyApi + 'newsFlash';
      return;
    } else if (name =='articleDetail') {
      if (window.location.href.indexOf('preview')>-1){
        window.location.href = mcyApi + 'articleDetail/preview/' + window.location.pathname.split('/')[2];
      } else {
        window.location.href = mcyApi + 'articleDetail/' + window.location.pathname.split('/')[2];
      }
      return;
    } else if (name =='videoDetail') {
      if (window.location.href.indexOf('preview')>-1){
        window.location.href = mcyApi + 'videoDetail/pre/' + window.location.pathname.split('/')[2];
      } else {
        window.location.href = mcyApi + 'videoDetail/' + window.location.pathname.split('/')[2];
      }
      return;
    } else if (name == 'videoList'){
      window.location.href =  mcyApi + 'videoList';
      return;
    } else if (name == 'articleList'){
        window.location.href = mcyApi + 'lanmu/' + window.location.pathname.split('/')[2];
        return;
    }
  }
  store.commit('GET_USERINFO');
  next();
});
router.afterEach( ( to, from, next ) => {
  // (function (G,D,s,c,p) {
  //     c={//监测配置
  //       UA:"UA-cheyun-000001",//客户项目编号,由系统生成
  //       NO_FLS:1,
  //       WITH_REF:1,
  //       URL:"//"+window.location.hostname + "/static/iwt-min.js",
  //       API_URL:"//irs01.com/irt?"
  //     };
  //     G._iwt?G._iwt.track(c,p):(G._iwtTQ=G._iwtTQ || []).push([c,p]),!G._iwtLoading && lo();
  //     function lo(t) {
  //       G._iwtLoading=1;s=D.createElement("script");s.src=c.URL;
  //       t=D.getElementsByTagName("script");t=t[t.length-1];
  //       t.parentNode.insertBefore(s,t);
  //     }
  // })(this,document);
} );
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 }
    }
  },
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js